import {
  BooleanInput,
  FormDataConsumer,
  Labeled,
  SelectInput,
  useTranslate,
} from 'react-admin'
import React from 'react'
import { productStatusChoices } from 'services/cfg/form'
import { EventFormDataConsumerProps } from '../GeneralTab'
import EventServiceBriefSection from 'ui-shared/FormComponents/EventServiceBriefSection'
import { isLocationObsolete } from '../../utils'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import KRichTextInput from 'ui-shared/WrappedInputs/KRichTextInput'
import EventServiceSection from '../../EventsComponents/EventServiceSection'
import CustomizationInput from 'ui-shared/FormComponents/CustomizationInput'
import { TailoredEventSelectionInput } from 'ui-shared/FormComponents/TailoredEventSelectionInput'
import LocationSelectionDetailsForm from './LocationSelectionDetailsForm'
import useService from '../hooks/useService'
import useSelections from '../hooks/useSelections'
import KFormTab from 'ui-shared/WrappedInputs/KFormTab'
import { Badge } from '@mui/material'

const LocationFormTab: React.FC = (props) => {
  const { hasSelections } = useSelections('locations')
  const { hasCustomization } = useService('locationService')

  const translate = useTranslate()

  return (
    <KFormTab
      {...props}
      label={
        <Badge
          badgeContent={hasSelections || hasCustomization ? 1 : 0}
          color="primary"
          variant="dot"
        >
          {translate('form.tabs.location')}
        </Badge>
      }
    >
      <SelectInput
        source="locationStatus"
        label="form.fields.status"
        choices={productStatusChoices}
        defaultValue={productStatusChoices[0].id}
      />

      <EventServiceSection source="locationService" />

      <KRichTextInput source="locationNotes" label="form.fields.notes" />

      {/* Locations input */}
      <TailoredEventSelectionInput
        entity="locations"
        label="form.fields.locations"
        source="locations"
        getIsProductObsolete={isLocationObsolete}
        hideQuantity
      >
        <LocationSelectionDetailsForm />
      </TailoredEventSelectionInput>

      {/* brief section */}
      {
        <FormDataConsumer>
          {({ formData }: EventFormDataConsumerProps) => {
            // this is needed in the case of the create view where the record
            // doesn't have the productServices property
            const service = formData.productServices?.locationService

            return (
              <React.Fragment>
                <CustomizationInput
                  source={`productServices.locationService.customization`}
                  customization={service?.customization}
                />
                {service?.briefQuestions && service?.briefQuestions.length ? (
                  <React.Fragment>
                    <Kdivider title="Event Brief" headingLevel="h3" />
                    <Labeled label="form.fields.briefConfirmation">
                      <BooleanInput
                        source={`productServices.locationService.briefConfirmed`}
                        label={service?.briefConfirmed ? 'Yes' : 'No'}
                        disabled
                      />
                    </Labeled>
                    <EventServiceBriefSection
                      serviceSource={`productServices.locationService`}
                    />
                  </React.Fragment>
                ) : null}
              </React.Fragment>
            )
          }}
        </FormDataConsumer>
      }
    </KFormTab>
  )
}

export default LocationFormTab
